module.exports = __webpack_public_path__ + "static/img/signupImg.a18a32a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Signup/signupImg.jpeg
// module id = gMqv
// module chunks = 37